import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useSelector } from 'react-redux';

const GpuCountField = (props) => {
  const gpu_classes = useSelector((state) => state.gpuClasses || []);

  let max_per_worker = 8;
  props.gpu_types.forEach((gpu_type_id) => {
    const selected_gpu_class = gpu_classes.find(
      (gpu_class) => gpu_class.id === gpu_type_id
    );
    if (selected_gpu_class) {
      max_per_worker = Math.min(
        selected_gpu_class.max_per_worker,
        max_per_worker
      );
    }
  });

  const handleChange = (event) => {
    // Convert MUI event to Semantic UI-like format for compatibility
    const synthetic_event = {
      target: event.target,
      currentTarget: event.currentTarget,
    };
    props.onChange(synthetic_event, {
      name: 'gpu_count',
      value: event.target.value,
    });
  };

  const options = [1, 2, 4, 8].map((count) => ({
    value: count,
    disabled: max_per_worker < count,
  }));

  return (
    <FormControl fullWidth>
      <InputLabel id='gpu-count-label'>
        {props.type === 'training' ? 'GPUs Per Worker' : 'GPU Count'}
      </InputLabel>
      <Select
        labelId='gpu-count-label'
        id='gpu-count'
        name='gpu_count'
        value={props.gpu_count}
        label={props.type === 'training' ? 'GPUs Per Worker' : 'GPU Count'}
        onChange={handleChange}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GpuCountField;

